<template>
  <div class="c-carousel">
    <div
      class="c-carousel__track"
      :class="{ 'c-carousel__track--no-padding': count === 1 }"
    >
      <img
        :src="`content/${this.id}/gallery-${this.imgIndex}.jpg`"
        :srcset="`content/${this.id}/gallery-${this.imgIndex}@2x.jpg 2x`"
      />
    </div>
    <button
      v-if="count > 1"
      @click="prevImage"
      :class="{ disabled: this.imgIndex === 1 }"
      class="c-carousel__btn c-carousel__btn-prev"
    >
      <LeftArrowAnimation />
    </button>
    <div class="c-carousel__counter" v-if="count > 1">
      <span class="c-carousel__counter-active">{{ this.imgIndex }}</span> of
      <span class="c-carousel__counter-total">{{ this.count }}</span>
    </div>
    <button
      v-if="count > 1"
      @click="nextImage"
      :class="{ disabled: this.imgIndex === this.count }"
      class="c-carousel__btn c-carousel__btn-next"
    >
      <RightArrowAnimation />
    </button>
  </div>
</template>

<script>
import LeftArrowAnimation from "@/components/animations/LeftArrowAnimation.vue";
import RightArrowAnimation from "@/components/animations/RightArrowAnimation.vue";

export default {
  components: { LeftArrowAnimation, RightArrowAnimation },
  props: ["id", "count"],
  data() {
    return {
      imgIndex: 1,
      counterTotal: this.count,
    };
  },
  methods: {
    nextImage() {
      this.imgIndex = this.imgIndex + 1;
    },
    prevImage() {
      this.imgIndex = this.imgIndex - 1;
    },
  },
};
</script>
